'use client';

import { useState } from 'react';

interface ShipperInputPageProps {
  initialValue: string;
  onChange: (value: string) => void;
  onNext: () => void;
}

export default function ShipperInputPage({ initialValue, onChange, onNext }: ShipperInputPageProps) {
  const [shipperName, setShipperName] = useState(initialValue);

  // props 변경 시 동기화 (렌더 중 조정 — effect 내 setState 회피)
  const [prevInitialValue, setPrevInitialValue] = useState(initialValue);
  if (prevInitialValue !== initialValue) {
    setPrevInitialValue(initialValue);
    setShipperName(initialValue);
  }

  const handleChange = (value: string) => {
    setShipperName(value);
    onChange(value);
  };

  const handleNext = () => {
    if (shipperName.trim()) {
      onNext();
    }
  };

  return (
    <div className="h-full bg-gray-50 flex flex-col items-center justify-between py-8 px-8">
      {/* Header */}
      <div className="text-center pt-4">
        <h1 className="text-6xl font-bold text-gray-800 font-sans">Demo Pallet 키오스크</h1>
      </div>

      {/* Main Content */}
      <div className="flex flex-col items-center w-full max-w-2xl">
        <div className="flex items-center space-x-12">
          <label className="text-4xl font-medium text-gray-700 whitespace-nowrap">화주명을 입력하세요</label>

          <input
            type="text"
            value={shipperName}
            onChange={(e) => handleChange(e.target.value)}
            placeholder="화주명 입력"
            className="w-72 h-16 text-3xl text-center bg-gray-400 border-none text-white placeholder-gray-200 rounded-lg focus:ring-4 focus:ring-blue-300 focus:outline-none"
          />
        </div>
      </div>

      {/* Bottom Section */}
      <div className="w-full flex justify-between items-end px-8">
        {/* Footer */}
        <div className="text-gray-500 text-lg">
          터치스크린을 사용하여 입력해주세요
        </div>

        <button
          onClick={handleNext}
          disabled={!shipperName.trim()}
          className={`text-white px-10 py-5 text-2xl font-bold transition-all duration-300 transform hover:scale-105 disabled:hover:scale-100 flex items-center justify-center gap-3 ${
            shipperName.trim() ? 'bg-orange-500 hover:bg-orange-600 cursor-pointer' : 'bg-orange-300 cursor-not-allowed'
          }`}
          style={{
            clipPath: 'polygon(0 0, calc(100% - 24px) 0, 100% 50%, calc(100% - 24px) 100%, 0 100%)',
          }}
        >
          <span>다음</span>
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-white"
          >
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
